import { FC } from "react"
import { Button } from "@/ui/Button"
import styles from "./StorageSection.module.scss"

export const StorageSection: FC = () => {
  const handleClearAndReload = () => {
    localStorage.clear()
    sessionStorage.clear()
    window.location.reload()
  }

  return (
    <section className={styles.StorageSection}>
      <h3 className={styles.StorageSection_title}>Storage</h3>
      <Button
        className={styles.StorageSection_button}
        styles="green"
        onClick={handleClearAndReload}
      >
        Clear & Reload
      </Button>
    </section>
  )
}
